// TBYB Add-On Variant Cleanup Script
// Removes Add-On variants when none of their target variants are present in the cart

;(function() {
  // —————————————————————————————————————
  // Configuration: [ targetVariantId, addonVariantId ]
  // —————————————————————————————————————
  var TBYB_ADDON_MAPPINGS = [
    // One-time purchase variants mapped to their Try Before You Buy add-ons
    // Format: [ targetVariantId, addonVariantId ]
    [45815821140020, 43518107385908],  // Neck Cream (one-time) → Try Before You Buy
    [45818476625972, 43518107385908],  // Arm Cream (one-time)
    [46204561522740, 43518107385908],  // B/T Cream (one-time)
    [45897069723700, 43518107385908],  // Eye Cream (one-time)
    [45897070542900, 43518107385908],  // Anti-Wrinkle Cream (one-time)
    [46919571406900, 43518107385908],  // Arm Cream Add On (one-time)

    // Subscription variants mapped to their Try Before You Buy add-ons
    // Format: [ targetVariantId, addonVariantId ]
    [45815815307316, 46906318159924],  // Neck Cream (subscription)
    [45818468073524, 46906330382388],  // Arm Cream (subscription)
    [46204561489972, 46906337067060],  // B/T Cream (subscription)
    [45897069690932, 46906342834228],  // Eye Cream (subscription)
    [45897070510132, 46906348404788]   // Anti-Wrinkle Cream (subscription)
  ];

  // Fetch current cart via AJAX
  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    }).then(function(response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  // Update cart quantities via AJAX
  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function(response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  // Core logic: remove add-on variants if their target is missing
  function removeOrphanAddOns() {
    fetchCart().then(function(cart) {
      var updates = {};
      TBYB_ADDON_MAPPINGS.forEach(function(pair) {
        var targetId = pair[0];
        var addonId  = pair[1];
        var hasTarget = cart.items.some(function(item) {
          return item.variant_id === targetId;
        });
        var hasAddOn = cart.items.some(function(item) {
          return item.variant_id === addonId;
        });
        if (!hasTarget && hasAddOn) {
          updates[addonId] = 0;
        }
      });

      // If there are any addons to remove, send update and reload cart drawer
      if (Object.keys(updates).length > 0) {
        updateCart(updates).then(function() {
          renderCartDrawer()
        }).catch(function(error) {
          console.error('Failed to remove TBYB add-ons:', error);
        });
      }
    }).catch(function(error) {
      console.error('TBYB script error fetching cart:', error);
    });
  }

  // Run on initial page load
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(removeOrphanAddOns, 2000)
  });

  // Observe cart changes to trigger cleanup after cart updates
  const observeCartChange = () => {
    const targetNode = document.querySelector('#cart-icon-bubble')
    const observer = new MutationObserver(() => {
      setTimeout(() => { removeOrphanAddOns() }, 3000)
    })
    observer.observe(targetNode, {
      childList: true,
    })
  }

  observeCartChange()



  async function renderCartDrawer() {
    // Update Cart Drawer
    fetch(window.Shopify.routes.root + "?sections=cart-drawer")
      .then((res) => res.json()) // Parse the response as JSON
      .then((data) => {
        const cartDrawer = document.querySelector("cart-drawer");
        // Convert the HTML string into a document object that can be parsed to replace the cart drawer
        const parser = new DOMParser();
        const doc = parser.parseFromString(data["cart-drawer"], "text/html");
        // Get the new cart drawer and replace the existing one, and check if is empty to add class
        cartDrawer.querySelector(".drawer__inner").replaceWith(doc.querySelector(".drawer__inner"));
        if (doc.querySelector("cart-drawer").classList.contains("is-empty")) {
          cartDrawer.classList.add("is-empty");
        } else {
          cartDrawer.classList.remove("is-empty");
        }
      })
      .catch((error) => {
        console.error("Error reloading cart drawer: ", error);
      });
    // Update Cart Icon Bubble
    fetch(window.Shopify.routes.root + "?sections=cart-icon-bubble")
      .then((res) => res.json()) // Parse the response as JSON
      .then((data) => {
        const cartIconBubble = document.querySelector("#cart-icon-bubble");
        // Convert the HTML string into a document object that can be parsed to replace the cart drawer
        const parser = new DOMParser();
        const doc = parser.parseFromString(data["cart-icon-bubble"], "text/html");
        // Get the new cart drawer and replace the existing one, and check if is empty to add class
        cartIconBubble.innerHTML = doc.querySelector(".shopify-section").innerHTML;
      })
      .catch((error) => {
        console.error("Error reloading cart bubble count: ", error);
      });
  }


})();


